import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Footer from '../../components/Footer';
import CalculationResultPart from '../../components/CalculationResultPart';
import { Helmet } from "react-helmet-async";
import { Link } from 'react-router-dom';
import LocalDatePicker from '../../components/LocalDatePicker';
import { differenceInBusinessDays, differenceInDays } from "date-fns";
import Header from '../../components/Header';

const faqs = [
    {
        question: "<h5>İş Günü Tanımı:</h5>",
        answer: ["İş günü, yasal düzenlemeler çerçevesinde hafta içi tatil günleri hariç kalan ve çalışma faaliyetleri için ayrılan günleri ifade eder. Bir başka deyişle, iş sözleşmesinde belirtilen çalışma haftanızın hafta sonu ve resmi tatiller hariç kalan kısımlarını çalışma günü olarak adlandırabiliriz."],
    },
    {
        question: "<h5>İş Günü Hesaplama Aşamaları:</h5>",
    },
    {
        question: "<h5>1. Başlangıç ve Bitiş Tarihlerinin Belirlenmesi:</h5>",
        answer: ["Hesaplama yapmak istediğiniz zaman aralığının ilk ve son günlerini net bir şekilde belirlemeniz önemlidir."]
    },
    {
        question: "<h5>2. Toplam Gün Sayısının Hesaplanması:</h5>",
        answer: ["Başlangıç ve bitiş tarihleri arasındaki tüm günleri saymanız gerekir. Bu işlemde artık yılların da hesaba katılması önemlidir. Örneğin, 28 Şubat 2024 ile 10 Mart 2024 tarihleri arasındaki gün sayısını hesaplıyorsanız, 1 Mart'ın artık yıl günü olması sebebiyle aradaki 11 gün yerine 12 gün saymalısınız."]
    },
    {
        question: "<h5>3. Tatil Günlerinin Göz Önünde Bulundurulması:</h5>",
        answer: ["İş günü hesaplamasında bir sonraki adım, tatil günlerini belirlemektir. Bu noktada iki seçeneğiniz var:<p><strong>a. Sadece Hafta Sonları:</strong> Eğer sadece cumartesi ve pazar günlerini tatil olarak kabul ediyorsanız, hesapladığınız toplam gün sayısından hafta sonu günlerini çıkarmanız yeterlidir.</p><p><strong>b. Tüm Tatilleri Dahil Etme:</strong> Resmi tatiller ve dini bayramları da hesaba katmak istiyorsanız, ilgili tarih aralığındaki resmi tatilleri ve bayramları internetten veya takvimlerden kontrol ederek toplam gün sayısından çıkarmanız gerekir.</p>",]
    },
];

const IsGunuHesaplama = () => {
	const [hideAll, setHideAll] = useState(false);
	const [results, setResults] = useState([]);
	const [calculated, setCalculated] = useState(false);

	const [iseGirisTarihi, setIseGirisTarihi] = useState(null);
	const [istenCikisTarihi, setIstenCikisTarihi] = useState(null);

	const location = useLocation();
	const navigate = useNavigate();

	useEffect(() => {
		const query = new URLSearchParams(location.search);

		if (query.toString()) {
			const parsedResults = query.get('results');
			if (parsedResults) {
				setResults(JSON.parse(decodeURIComponent(atob(parsedResults))));
			}
            setIseGirisTarihi(new Date(decodeURIComponent(atob(query.get('iseGirisTarihi')))));
            setIstenCikisTarihi(new Date(decodeURIComponent(atob(query.get('istenCikisTarihi')))));
			setCalculated(true);
		}

		localStorage.setItem('referrer', `${window.location.origin}${window.location.pathname}`);
	}, [location.search]);

	const calculate = () => {
		if (iseGirisTarihi && istenCikisTarihi) {
            const newResults = [
                { text: "Toplam Çalışma Süresi", value: Math.abs(differenceInDays(iseGirisTarihi, istenCikisTarihi)) },
                { text: "Toplam İş Günü Sayısı", value: Math.abs(differenceInBusinessDays(iseGirisTarihi, istenCikisTarihi)) }
            ];

            setHideAll(true);

            const params = new URLSearchParams({
				results: btoa(encodeURIComponent(JSON.stringify(newResults))),
				iseGirisTarihi: btoa(encodeURIComponent(new Date(iseGirisTarihi).toISOString())),
				istenCikisTarihi: btoa(encodeURIComponent(new Date(istenCikisTarihi).toISOString())),
			});

			navigate(`${window.location.pathname}?${params.toString()}`);
			navigate(0);
		} else {
			alert("Lütfen tüm değerleri doğru girdiğinizden emin olunuz!");
		}
	};

    return (
        <>
            <Helmet>
                <title>İş Günü Hesaplama - Legalbul</title>
                <link rel="canonical" href={`${window.location.origin}${window.location.pathname}`} />
                <meta name="description" content="İş günü, hafta içi tatil günleri hariç olmak üzere çalışma faaliyetleri için ayrılan günlerdir. Hafta sonu ve resmi tatiller dışındaki günler iş günü sayılır." />
            </Helmet>
            
            <Header />
            <section className="container my-5 bg-white shadow-sm p-0">
                <div className="p-4">
                    <ol className="breadcrumbnav">
                        <li>
                            <Link to="/">Ana Sayfa</Link>
                        </li>
                        <li>
                            <Link to="/hesaplamalar">Tüm Hesaplamalar</Link>
                        </li>
                        <li>İş Günü Hesaplama</li>
                    </ol>
                    <h1 className="fw-semibold">İş Günü Hesapla</h1>
                    <p>İş günü, hafta içi tatil günleri hariç olmak üzere çalışma faaliyetleri için ayrılan günlerdir. Hafta sonu ve resmi tatiller dışındaki günler iş günü sayılır.</p>
                    
                    <LocalDatePicker label="İşe Giriş Tarihiniz" setValue={setIseGirisTarihi} value={iseGirisTarihi} />
                    <LocalDatePicker label="İşten Çıkış Tarihiniz" setValue={setIstenCikisTarihi} value={istenCikisTarihi} />
                </div>

                <CalculationResultPart calculated={calculated} hideAll={hideAll} results={results} calculate={calculate} trailText='gün' />
            </section>
            
            <Footer faqs={faqs} faqTitle="İş Günü Hakkında Bilmeniz Gerekenler" />
        </>
    );
};

export default React.memo(IsGunuHesaplama);
